import {
    saveRequest, removeRequest, getRequest, FilemanagerApi,
} from '@requests';
import {v4 as uuid} from 'uuid';
import {loadingApplication, addNotification, openWrongPage} from '@componentDP/js_react/redux/actions/application';
import {
    getCommentFromCommentsZajavls,
    removeCommentFromCommentsZajavls,
    setUidContests,
} from '@helpers/functions';
import {findIndex, isEmpty, uniq} from 'lodash';
import {filesInfoReceived} from '@componentDP/js_react/redux/actions/files';
import {mappingZajavls, mappingSprCompetitionsZajavls} from '@helpers/mapping_fields';
import {setExams, setApplicantExams} from '@componentDP/js_react/redux/actions/exams';
import {
    ZAJAVLS,
    LOADING_ZAJAVLS,
    LOADED_ZAJAVLS,
    CONTEST_DIALOG_OPEN_ZAJAVLS,
    CONTEST_EDIT_FORM_ZAJAVLS,
    ZAJAVL_EDIT_UUID_ZAJAVLS,
    SPR_COMPETITIONS_ZAJAVLS,
    SPR_ALLOWED_FOR_ADMISSION_COMP_GROUPS_NAMES,
    ALLOWED_ONLINE_ZAJAVLS,
    REQUIREMENTS_DOCUMENTS_ZAJAVLS,
    TEMPLATES_DOCUMENTS_ZAJAVLS,
    COMMENTS_ZAJAVLS,
    HISTORY_ZAJAVL,
    LOADING_HISTORY_ZAJAVL,
} from '../store/actionTypes';
import {useTranslation} from "react-i18next";

export function initializationZajavls() {
    return async (dispatch, getState) => {
        const {apiDomainVikon, apiDomainFilemanager, profileBasic} = getState();
        if (Number(profileBasic.diploma_id) > 0) {
            dispatch(setLoadingZajavls(true));
            const chainPromises = [
                getRequest(`${apiDomainVikon}api/digital_profile/applicant/zajavls`),
                // на какие конкурсы вообще сейчас можно поступать
                getRequest(`${apiDomainVikon}api/digital_profile/spr/spr_competitions/active`),
                // когда добавили новый конкурс в заявку - нужно получить его имя, справочник имен
                getRequest(`${apiDomainVikon}api/digital_profile/spr/spr_competitions/active/competition_groups_names`),

                getRequest(`${apiDomainVikon}api/digital_profile/spr/spr_campaigns/is_zajavs_being_accepted`),
                // уровни обр из активно кампании
                getRequest(`${apiDomainVikon}api/digital_profile/campaign/edu_levels/admission_available`),
                // получение справочника вступительных испытаний
                getRequest(`${apiDomainVikon}api/digital_profile/exams`),
                // получение экзаменов абитуриента
                getRequest(`${apiDomainVikon}api/digital_profile/applicant_exam`),
                getRequest(`${location.origin}/sveden/update/api_profile_applicant/get_templates.php`),
            ];
            Promise.all(chainPromises)
                .then(async (values) => {
                    const [
                        zajavls,
                        sprCompetitions,
                        allowedForAdmissionCompGroupsNames,
                        allowedOnlineResp,
                        admissionAvailable,
                        exams,
                        applicantExams,
                        templatesDocuments,
                    ] = values;
                    if (zajavls.hasOwnProperty('errors')) {
                        throw new Error(zajavls.errors);
                    }
                    if (sprCompetitions.hasOwnProperty('errors')) {
                        throw new Error(sprCompetitions.errors);
                    }
                    if (allowedForAdmissionCompGroupsNames.hasOwnProperty('errors')) {
                        throw new Error(allowedForAdmissionCompGroupsNames.errors);
                    }

                    if (allowedOnlineResp.hasOwnProperty('errors')) {
                        throw new Error(allowedOnlineResp.errors);
                    }
                    if (admissionAvailable.hasOwnProperty('errors')) {
                        throw new Error(admissionAvailable.errors);
                    }
                    if (exams.hasOwnProperty('errors')) {
                        throw new Error(exams.errors);
                    }
                    if (applicantExams.hasOwnProperty('errors')) {
                        throw new Error(applicantExams.errors);
                    }
                    if (templatesDocuments.hasOwnProperty('errors')) {
                        throw new Error(templatesDocuments.errors);
                    }

                    let fileIds = [];
                    for (const zajavl of zajavls) {
                        zajavl.uuid = uuid();
                        if (zajavl.hasOwnProperty('file_ids') && !isEmpty(zajavl.file_ids) && Array.isArray(zajavl.file_ids)) {
                            fileIds = fileIds.concat(zajavl.file_ids);
                        }
                        zajavl.contests = setUidContests(zajavl.request_competitions);
                        delete zajavl.request_competitions;
                    }
                    if (!isEmpty(fileIds)) {
                        fileIds = uniq(fileIds);
                        const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
                        const result = await filemanagerApi.getFilesInfo(fileIds);
                        dispatch(filesInfoReceived(result));
                    }
                    dispatch(setZajavls(zajavls));
                    dispatch(setSprCompetitionsZajavls(sprCompetitions));
                    dispatch(setAllowedForAdmissionCompGroupsNames(allowedForAdmissionCompGroupsNames));

                    const status = allowedOnlineResp.status === true;
                    dispatch(setAllowedOnlineZajavls(status));

                    dispatch(setExams(exams));
                    dispatch(setApplicantExams(applicantExams));
                    dispatch(setRequirementsDocuments(admissionAvailable));
                    dispatch(setTemplatesDocuments(templatesDocuments));
                    dispatch(setLoadingZajavls(false));
                })
                .catch((e) => {
                    dispatch(addNotification({message: e.message, type: 'error'}));
                    dispatch(openWrongPage());
                });
        }
    };
}
export function addZajavl() {
    return (dispatch, getState) => {
        const {zajavls} = getState();
        dispatch(setZajavls([...zajavls, {uuid: uuid(), contests: []}]));
    };
}
export function addContestZajavls(currentLang) {
    return async (dispatch, getState) => {
        try {
            const {
                zajavls,
                zajavlEditUuidZajavls,
                contestEditFormZajavls,
                sprAllowedForAdmissionCompGroupsNames,
                apiDomainVikon,
            } = getState();
            const zajavlsModify = [];
            for (const zajavl of zajavls) {
                const zajavlModify = {...zajavl};
                if (zajavl.uuid === zajavlEditUuidZajavls) {
                    contestEditFormZajavls.competition_group_name = sprAllowedForAdmissionCompGroupsNames[contestEditFormZajavls.competition_group_id]
                        ? currentLang === 'en' && sprAllowedForAdmissionCompGroupsNames[contestEditFormZajavls.competition_group_id].value_en
                            ? sprAllowedForAdmissionCompGroupsNames[contestEditFormZajavls.competition_group_id].value_en
                            : sprAllowedForAdmissionCompGroupsNames[contestEditFormZajavls.competition_group_id].value
                        : '-';

                    // получаем требуемые экзамены для выбранного конкурса
                    const contestExams = await saveRequest(
                        `${apiDomainVikon}api/digital_profile/applicant/zajavls/exams/by_request_competitions`,
                        {contest: JSON.stringify(contestEditFormZajavls)},
                    );
                    if (contestExams.errors) {
                        throw new Error(contestExams.errors);
                    }
                    zajavlModify.contests.push({...contestEditFormZajavls, uuid: uuid(), exams: contestExams});
                }
                zajavlsModify.push(zajavlModify);
            }
            dispatch(setZajavls(zajavlsModify));
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        }
    };
}

export function removeContestZajavl(contestUuid, t) {
    return async (dispatch, getState) => {
        try {
            dispatch(loadingApplication(true));
            const {zajavls} = getState();
            const zajavlsModify = [];
            for (const zajavl of zajavls) {
                const zajavlModify = {...zajavl};
                const contestsModify = [];
                const {contests} = zajavlModify;
                for (const contest of contests) {
                    if (contest.uuid !== contestUuid) {
                        contestsModify.push({...contest});
                    }
                }
                zajavlModify.contests = contestsModify;
                zajavlsModify.push(zajavlModify);
            }
            dispatch(setZajavls(zajavlsModify));
            dispatch(addNotification({message: t('deleted'), type: 'success'}));
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(loadingApplication(false));
        }
    };
}

export function saveAndSendZajavl(zajavlUuid, successSaveCallback, t) {
    return async (dispatch, getState) => {
        try {
            const {zajavls, commentsZajavls, apiDomainVikon} = getState();
            dispatch(loadingApplication(true));
            const zajavlsModify = [];
            for (let zajavl of zajavls) {
                zajavl = {...zajavl};
                if (zajavl.uuid === zajavlUuid) {
                    zajavl.request_competitions = JSON.stringify(zajavl.contests);
                    zajavl.file_ids = zajavl.hasOwnProperty('file_ids') && !isEmpty(zajavl.file_ids)
                        ? zajavl.file_ids
                        : [];
                    zajavl.comment = getCommentFromCommentsZajavls(commentsZajavls, zajavlUuid);

                    const savedZajavl = await saveRequest(
                        `${apiDomainVikon}api/digital_profile/applicant/zajavls${zajavl.id ? `/${zajavl.id}` : ''}`,
                        zajavl,
                    );
                    if (savedZajavl.errors) {
                        throw new Error(savedZajavl.errors);
                    }
                    savedZajavl.uuid = zajavl.uuid;
                    savedZajavl.contests = setUidContests(savedZajavl.request_competitions);
                    savedZajavl.results = savedZajavl.hasOwnProperty('results') && !isEmpty(savedZajavl.results)
                        ? savedZajavl.results
                        : [];
                    savedZajavl.status = Number(savedZajavl.status);
                    zajavlsModify.push(savedZajavl);
                } else {
                    const zajavlModify = {...zajavl};
                    zajavlsModify.push(zajavlModify);
                }
            }
            dispatch(setZajavls(zajavlsModify));
            dispatch(addNotification({message: t('zajavl_send_to_modaeration'), type: 'success'}));
            await successSaveCallback();
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(loadingApplication(false));
        }
    };
}
export function removeZajavl(zajavlUuid, t) {
    return async (dispatch, getState) => {
        try {
            const {zajavls, apiDomainVikon} = getState();
            dispatch(loadingApplication(true));
            const zajavlsModify = [];
            for (const zajavl of zajavls) {
                if (zajavl.uuid === zajavlUuid) {
                    if (zajavl.id) {
                        const removedZajavl = await removeRequest(`${apiDomainVikon}api/digital_profile/applicant/zajavls`, zajavl.id);
                        if (removedZajavl.errors) {
                            throw new Error(removedZajavl.errors);
                        }
                    }
                } else {
                    zajavlsModify.push({...zajavl});
                }
            }
            dispatch(setZajavls(zajavlsModify));
            dispatch(addNotification({message: t('zajavl_deleted'), type: 'success'}));
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(loadingApplication(false));
        }
    };
}
export function cancelZajavl(zajavlUuid, t) {
    return async (dispatch, getState) => {
        try {
            const {zajavls, commentsZajavls, apiDomainVikon} = getState();
            dispatch(loadingApplication(true));
            const zajvalsModify = [];
            for (const zajavl of zajavls) {
                if (zajavl.uuid === zajavlUuid) {
                    const commentValue = getCommentFromCommentsZajavls(commentsZajavls, zajavlUuid);
                    const canceledZajavl = await saveRequest(`${apiDomainVikon}api/digital_profile/applicant/zajavls/${zajavl.id}/actions/cancel`, {comment: commentValue});
                    if (canceledZajavl.errors) {
                        throw new Error(canceledZajavl.errors);
                    }
                    const commentsZajalsModify = removeCommentFromCommentsZajavls(commentsZajavls, zajavlUuid);
                    dispatch(setCommentsZajavls(commentsZajalsModify));
                    const zajval = Object.assign(zajavl, canceledZajavl);
                    zajval.status = Number(zajval.status);
                    zajvalsModify.push({...zajval});
                } else {
                    zajvalsModify.push({...zajavl});
                }
            }
            dispatch(setZajavls(zajvalsModify));
            dispatch(addNotification({message: t('zajavl_reject'), type: 'success'}));
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(loadingApplication(false));
        }
    };
}
export function modifyZajavl(uuid, object) {
    return (dispatch, getState) => {
        const {zajavls} = getState();
        const zajavlsModify = [];
        zajavls.forEach((zajavl) => {
            if (zajavl.uuid === uuid) {
                const zajavlModify = Object.assign(zajavl, object);
                zajavlsModify.push({...zajavlModify});
            } else {
                zajavlsModify.push({...zajavl});
            }
        });
        dispatch(setZajavls(zajavlsModify));
    };
}
export function modifyComment(zajavlUuid, value) {
    return (dispatch, getState) => {
        const {commentsZajavls} = getState();
        const commentsZajavlsCopy = commentsZajavls.slice();
        const indexComment = findIndex(commentsZajavlsCopy, {zajavl_uuid: zajavlUuid});
        if (indexComment !== -1) {
            commentsZajavlsCopy[indexComment].value = value;
        } else {
            commentsZajavlsCopy.push({zajavl_uuid: zajavlUuid, value});
        }
        dispatch(setCommentsZajavls(commentsZajavlsCopy));
    };
}
export function setZajavls(list) {
    list = mappingZajavls(list);
    return {
        type: ZAJAVLS,
        list,
    };
}
export function getHistoryZajavl(zajavlUuid, t) {
    return async (dispatch, getState) => {
        try {
            dispatch(setLoadingHistoryZajavl(true));
            const {zajavls, apiDomainVikon} = getState();
            const zajavlIndex = findIndex(zajavls, {uuid: zajavlUuid});
            if (zajavlIndex === -1) {
                throw new Error(t('zajavl_not_found'));
            }
            const zajavl = zajavls[zajavlIndex];
            const history = await getRequest(`${apiDomainVikon}api/digital_profile/applicant/zajavls/${zajavl.id}/statuses/history`);
            if (history.errors) {
                throw new Error(history.errors);
            }
            dispatch(setHistoryZajavl(history));
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(setLoadingHistoryZajavl(false));
        }
    };
}
export function setLoadingZajavls(status) {
    return {
        type: LOADING_ZAJAVLS,
        status,
    };
}
export function setLoadedZajavls(status) {
    return {
        type: LOADED_ZAJAVLS,
        status,
    };
}
export function setContestDialogOpenZajavls(status) {
    return {
        type: CONTEST_DIALOG_OPEN_ZAJAVLS,
        status,
    };
}
export function setContestEditFormZajavls(object) {
    return {
        type: CONTEST_EDIT_FORM_ZAJAVLS,
        object,
    };
}
export function setZajavlEditUuidZajavls(value) {
    return {
        type: ZAJAVL_EDIT_UUID_ZAJAVLS,
        value,
    };
}
export function setSprCompetitionsZajavls(list) {
    const listMapped = mappingSprCompetitionsZajavls(list);
    return {
        type: SPR_COMPETITIONS_ZAJAVLS,
        payload: listMapped,
    };
}

export function setAllowedForAdmissionCompGroupsNames(object) {
    return {
        type: SPR_ALLOWED_FOR_ADMISSION_COMP_GROUPS_NAMES,
        object,
    };
}

export function setAllowedOnlineZajavls(status) {
    return {
        type: ALLOWED_ONLINE_ZAJAVLS,
        status,
    };
}
export function setRequirementsDocuments(list) {
    list = list.map((row) => {
        row.id = Number(row.id);
        return row;
    });
    return {
        type: REQUIREMENTS_DOCUMENTS_ZAJAVLS,
        list,
    };
}
export function setTemplatesDocuments(object) {
    return {
        type: TEMPLATES_DOCUMENTS_ZAJAVLS,
        object,
    };
}
export function setCommentsZajavls(list) {
    return {
        type: COMMENTS_ZAJAVLS,
        list,
    };
}
export function setHistoryZajavl(list) {
    list.map((row) => {
        row.status = Number(row.status);
        row.is_vuz_create = Number(row.is_vuz_create);
        return row;
    });
    return {
        type: HISTORY_ZAJAVL,
        list,
    };
}
export function setLoadingHistoryZajavl(status) {
    return {
        type: LOADING_HISTORY_ZAJAVL,
        status,
    };
}
